<template>
  <container-app>
    <template #content>
      <!-- filter semester -->
      <div
        class="d-flex flex-column flex-md-row justify-content-between gap-3 mb-5 mx-5"
      >
        <div class="d-flex align-items-center gap-2">
          <label class="form-label m-0">Semester</label>
          <select
            class="form-select w-auto"
            v-model="jadwal_id"
            @change="indexPengusulanDana"
          >
            <option
              v-for="jadwal in data_jadwal_pengusulan"
              :key="jadwal.id"
              :value="jadwal.id"
            >
              {{ jadwal.semester }}
            </option>
          </select>
        </div>

        <a
          :href="base_url + 'download/pencairan/' + jadwal_id"
          target="_blank"
          class="btn btn-danger"
          v-if="
            lembaga_jabatan == 'LPPM STAF' ||
            lembaga_jabatan == 'LPPM KETUA' ||
            lembaga_jabatan == 'BAK KEPALA'
          "
          >Download</a
        >
      </div>

      <card-basic>
        <template #content>
          <table-basic>
            <template #thead>
              <tr class="fw-bolder bg-light fs-7">
                <th class="rounded-start ps-5 w-md-50px">No.</th>
                <th class="w-md-200px">Dosen</th>
                <th>Usulan PPM</th>
                <th class="rounded-end pe-5 w-md-200px">Aksi</th>
              </tr>
            </template>

            <template #tbody>
              <tr v-for="(pengusulan_dana, i) in data_pengusulan_dana" :key="i">
                <td class="text-end">{{ i + 1 }}</td>
                <td>
                  <span class="fw-bold d-block">{{
                    pengusulan_dana.nama
                  }}</span>
                  NIDN. {{ pengusulan_dana.nidn }}
                </td>
                <td>
                  <div
                    v-for="(dana, i) in pengusulan_dana.data_usulan"
                    :key="i"
                    :class="i > 0 ? 'mt-6' : ''"
                  >
                    <div class="d-flex justify-content-between">
                      <div>
                        <span>Usulan {{ i + 1 }}</span>
                        <span class="badge badge-info ms-3">{{
                          dana.jenis
                        }}</span>
                      </div>
                      <span
                        class="badge ms-3"
                        :class="
                          dana.keterangan == 'DICAIRKAN TAHAP 1' ||
                          dana.keterangan == 'DICAIRKAN TAHAP 2'
                            ? 'badge-success'
                            : 'badge-secondary'
                        "
                        >{{ dana.keterangan }}</span
                      >
                    </div>
                    <p class="fw-bold mb-1">{{ dana.judul }}</p>
                  </div>
                </td>
                <td>
                  <button
                    class="btn btn-sm btn-secondary"
                    data-bs-toggle="modal"
                    data-bs-target="#modalDetailUsulanPencairan"
                    @click="detailUsulanPencairan(i)"
                  >
                    Detail
                  </button>
                </td>
              </tr>
            </template>
          </table-basic>
        </template>
      </card-basic>
    </template>
  </container-app>

  <!-- begin::modal -->
  <modal-medium id="modalDetailUsulanPencairan" title="Detail Usulan Pencairan">
    <template #content>
      <div class="card border border-secondary">
        <div class="card-basic p-4">
          <label-basic name="Profil Dosen" />

          <div class="row mb-2 mt-3">
            <div class="col-sm-3">Nama Dosen</div>
            <div class="col-sm-9 fw-bold d-block">: {{ pengusul.nama }}</div>
          </div>
          <div class="row mb-2">
            <div class="col-sm-3">NIDN</div>
            <div class="col-sm-9 fw-bold d-block">: {{ pengusul.nidn }}</div>
          </div>
          <div class="row">
            <div class="col-sm-3">Program Studi</div>
            <div class="col-sm-9 fw-bold d-block">
              : {{ pengusul.program_studi }}
            </div>
          </div>
        </div>
      </div>

      <nav class="mt-4">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <button
            class="nav-link"
            :class="i == 1 ? 'active' : ''"
            id="nav-detail_usulan_ppm_usulan_1-tab"
            data-bs-toggle="tab"
            type="button"
            role="tab"
            aria-selected="true"
            v-for="i in jumlah_usulan"
            :key="i"
            @click="detailUsulanPencairan(index_usulan, i - 1)"
          >
            Usulan {{ i }}
          </button>
        </div>
      </nav>

      <div class="card border border-secondary">
        <div class="card-basic p-4">
          <label-basic name="Usulan Pencairan Dana" />

          <div class="row mb-2 mt-3">
            <div class="col-sm-3">Jenis</div>
            <div class="col-sm-9 fw-bold d-block">
              : {{ pengusulan_dana.jenis }}
            </div>
          </div>

          <div
            class="row mb-2"
            v-if="pengusulan_dana.jenis == 'LUARAN TAMBAHAN'"
          >
            <div class="col-sm-3">Luaran</div>
            <div class="col-sm-9 fw-bold d-block">
              : {{ pengusulan_dana.luaran_tambahan }}
            </div>
          </div>
          <div
            class="row mb-2"
            v-if="pengusulan_dana.jenis == 'LUARAN TAMBAHAN'"
          >
            <div class="col-sm-3">Kategori</div>
            <div class="col-sm-9 fw-bold d-block">
              : {{ pengusulan_dana.luaran_tambahan_kategori }}
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-sm-3">Judul</div>
            <div class="col-sm-9 fw-bold d-block">
              : {{ pengusulan_dana.judul }}
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-sm-3">Rencana Luaran</div>
            <div class="col-sm-9 fw-bold d-block">
              : {{ pengusulan_dana.target_iuran }}
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-sm-3">Dana Internal</div>
            <div class="col-sm-9 fw-bold d-block">
              : Rp. {{ pengusulan_dana.dana }}
            </div>
          </div>

          <!-- <div class="row mb-2">
            <div class="col-sm-3">
              Usulan Dana Tahap {{ pengusulan_dana.tahap }}
            </div>
            <div class="col-sm-9 fw-bold d-block">
              : Rp. {{ pengusulan_dana.biaya }}
            </div>
          </div> -->

          <div class="row mb-2">
            <div class="col-sm-3">File LOA</div>
            <div class="col-sm-9 fw-bold d-block">
              :
              <a
                :href="pengusulan_dana.link_file_loa"
                v-if="pengusulan_dana.link_file_loa != '-'"
                target="_blank"
                >Lihat File</a
              >
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-sm-3">File Artikel</div>
            <div class="col-sm-9 fw-bold d-block">
              :
              <a
                :href="pengusulan_dana.link_file_artikel"
                v-if="pengusulan_dana.link_file_artikel != '-'"
                target="_blank"
                >Lihat File</a
              >
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-sm-3">URL Artikel</div>
            <div class="col-sm-9 fw-bold d-block">
              :
              <a
                :href="pengusulan_dana.url_artikel"
                v-if="pengusulan_dana.url_artikel != '-'"
                target="_blank"
                >Kunjungi URL</a
              >
            </div>
          </div>
        </div>

        <div class="table-responsive mx-2">
          <table class="table gs-0 gy-4 table-hover table-row-dashed">
            <thead>
              <tr class="fw-bolder bg-light fs-7 text-center">
                <th style="width: 70px">Tahap</th>
                <th style="width: 150px">Nominal</th>
                <th>Status</th>
                <th style="width: 200px">Aksi</th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(usulan, index) in pengusulan_dana.data_usulan_dana"
                :key="index"
              >
                <td class="ps-2 text-center">{{ usulan.tahap }}</td>
                <td class="text-end">
                  Rp.
                  {{
                    usulan.biaya.toLocaleString("id-ID", {
                      style: "currency",
                      currency: "IDR",
                    })
                  }}
                </td>
                <td>
                  <span
                    class="badge"
                    :class="
                      usulan.status == 'DICAIRKAN'
                        ? 'badge-success'
                        : 'badge-secondary'
                    "
                    >{{ usulan.status }}</span
                  >
                </td>
                <td class="pe-2">
                  <div class="d-flex justify-content-center gap-2">
                    <button
                      class="btn btn-sm btn-primary"
                      v-if="lembaga_jabatan == usulan.validator"
                      @click="
                        validasiPengusulanDana(usulan.id, usulan.validator)
                      "
                    >
                      Validasi
                    </button>
                    <div
                      v-if="
                        usulan.status == 'DISETUJUI' &&
                        lembaga_jabatan == 'BAK KEPALA'
                      "
                    >
                      <div class="d-flex gap-2" v-if="usulan.tanggal == null">
                        <input
                          type="date"
                          class="form-control"
                          v-model="form_pengusulan_dana.tanggal"
                        />
                        <button
                          class="btn btn-sm btn-primary"
                          @click="updateTanggalPengusulanDana(usulan.id)"
                        >
                          Simpan
                        </button>
                      </div>
                    </div>

                    <a
                      :href="base_url + 'pdf/up/' + usulan.id"
                      target="_blank"
                      class="btn btn-sm btn-danger"
                      v-if="
                        usulan.tanggal != null &&
                        lembaga_jabatan != 'ITG REKTOR'
                      "
                    >
                      Download
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </modal-medium>
  <!-- end::modal -->
</template>

<script>
import {
  indexPengusulanDana,
  validasiPengusulanDana,
  showPengusulanDana,
  updateTanggalPengusulanDana,
} from "@/apis/pengusulanDana";
import { lembagaJabatan } from "@/apis/user";
import { indexJadwalPengusulan } from "@/apis/jadwalPengusulan";

export default {
  beforeMount() {
    localStorage.setItem("menu", "Penelitian");
    localStorage.setItem("halaman", "Pencairan");
  },
  data() {
    return {
      lembaga_jabatan: {},
      data_pengusulan_dana: {},
      pengusul: {},
      pengusulan_dana: {},
      form_pengusulan_dana: {},
      index_usulan: 0,
      jumlah_usulan: 0,
      detail: [false],
      jadwal_id: 0,
      data_jadwal_pengusulan: [],
      base_url: process.env.VUE_APP_BASE_URL,
      validator: "-",
    };
  },
  mounted() {
    this.indexJadwalPengusulan();
    this.lembagaJabatan();
    this.indexPengusulanDana();
  },
  methods: {
    async indexJadwalPengusulan() {
      const res = await indexJadwalPengusulan();

      this.data_jadwal_pengusulan = res.data.data;
    },
    async lembagaJabatan() {
      const res = await lembagaJabatan();

      this.lembaga_jabatan = res.data.lembaga_jabatan;
    },
    async indexPengusulanDana() {
      const res = await indexPengusulanDana(this.jadwal_id);

      this.data_pengusulan_dana = res.data.data;
      this.jadwal_id = res.data.jadwal_id;
    },
    detailUsulanPencairan(index, usulan = 0) {
      this.index_usulan = index;
      this.pengusul = this.data_pengusulan_dana[index];
      this.jumlah_usulan = this.pengusul.jumlah_usulan;

      this.showPengusulanDana(this.pengusul.data_usulan[usulan].id);
    },
    async validasiPengusulanDana(id, validasi) {
      const res = await validasiPengusulanDana({
        id: id,
        validasi: validasi,
      });

      if (res.status == 200) {
        Swal.fire({
          icon: "success",
          text: "Usulan pencairan berhasil divalidasi",
          showConfirmButton: false,
          timer: 3000,
        });

        this.indexPengusulanDana();
        this.showPengusulanDana(id);
      }
    },
    async showPengusulanDana(id) {
      this.pengusulan_dana = {};
      this.form_pengusulan_dana.tanggal = "";
      const res = await showPengusulanDana(id);

      this.pengusulan_dana = res.data.data;
    },
    async updateTanggalPengusulanDana(id) {
      if (this.form_pengusulan_dana.tanggal != "") {
        this.form_pengusulan_dana.id = id;
        const res = await updateTanggalPengusulanDana(
          this.form_pengusulan_dana
        );

        if (res.status == 200) {
          Swal.fire({
            icon: "success",
            text: "Tanggal pencairan berhasil diperbarui",
            showConfirmButton: false,
            timer: 3000,
          });
          this.detail[0] = false;
          this.showPengusulanDana(this.pengusulan_dana.id);
          this.indexPengusulanDana();
        }
      } else {
        Swal.fire({
          icon: "warning",
          text: "Tanggal tidak boleh kosong",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },
  },
};
</script>
